
    $(function() {
        var owl = $('.multicolumn-slider--wrapper'),
            owlOptions = {
              loop: false, 
              nav: false,
              items: 1,
              autoheight: true
            };
    
        if ( $(window).width() < 750  && !$('.multicolumn-slider--wrapper').hasClass('no-mobile-slider')) {
            var owlActive = owl.owlCarousel(owlOptions);
        } else {
            owl.addClass('off');
        }
    
        $(window).resize(function() {
            if ( $(window).width() < 750 && !$('.multicolumn-slider--wrapper').hasClass('no-mobile-slider') ) {
                if ( $('.multicolumn-slider--wrapper').hasClass('off') ) {
                    var owlActive = owl.owlCarousel(owlOptions);
                    owl.removeClass('off');
                }
            } else {
                if ( !$('.multicolumn-slider--wrapper').hasClass('off') ) {
                    owl.addClass('off').trigger('destroy.owl.carousel');
                    owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
                }
            }
        });
    });

